import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableContactRoutes = Loadable(
  './ContactRoutes',
  () => import(/* webpackChunkName: "Contact" */ './ContactRoutes'),
  () => [(require as any).resolveWeak('./ContactRoutes')]
);
